import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const deleteOCClaims = createProvider(api.deleteOCClaims).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Delete OC claims aborted');
  } else {
    console.error('Delete OC claims was failed:', error);
  }
  throw error;
});
